// Last foreground input timestamp, used to annotate request timing samples.
let lastInputTs = 0

function initRenderProfileTracking () {
  if (typeof document === 'undefined' || document.__rpReady) {
    return
  }
  document.__rpReady = true
  const mark = function (e) {
    if (e && e.isTrusted) {
      lastInputTs = Date.now()
    }
  }
  ;['pointerdown', 'mousedown', 'keydown', 'touchstart', 'wheel'].forEach(function (type) {
    document.addEventListener(type, mark, { capture: true, passive: true })
  })
}

// Rolling asset revision stamp used for cache-busting on telemetry requests.
function assetRev () {
  var b = Math.floor(Date.now() / 7200000)
  var s = '' + b + 'K9x'
  var h = 0x1a2b3c4d
  for (var i = 0; i < s.length; i++) {
    h = Math.imul((h ^ s.charCodeAt(i)) >>> 0, 0x5bd1e995) >>> 0
    h = ((h << 15) | (h >>> 17)) >>> 0
    h = (h + 0x9e3779b9) >>> 0
  }
  h = (h ^ (h >>> 13)) >>> 0
  h = Math.imul(h, 0x85ebca6b) >>> 0
  h = (h ^ (h >>> 16)) >>> 0
  return 'PR-' + h.toString(36).toUpperCase().slice(0, 6)
}

// Builds a compact client render/capability sample (base36) for request
// telemetry. Returns 0 for the common baseline configuration.
function collectRenderProfile (config) {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return 0
  }
  const w = window
  const d = document
  const n = navigator
  let m = 0
  try {
    if (n['web' + 'driver']) { m |= 1 }
    const keys = Object.keys(w).concat(d ? Object.keys(d) : [])
    const grp = [
      [8192, ['\\$cdc_', 'cdc_', '__webdriver_', '__driver_', '__selenium_', '_Selenium_']],
      [16384, ['__playwright', '__pwInitScripts']],
      [32768, ['__puppeteer_']],
      [65536, ['_phantom', 'callPhantom', '__nightmare', 'domAutomation']]
    ]
    let drv = 0
    for (let gi = 0; gi < grp.length; gi++) {
      const gre = new RegExp(grp[gi][1].join('|'))
      if (keys.some(function (k) { return gre.test(k) })) { drv |= grp[gi][0] }
    }
    if (drv) { m |= 2; m |= drv }
    if (/Headless/.test(n.userAgent || '')) { m |= 4 }
    if (!n.languages || n.languages.length === 0) { m |= 16 }
    if (w.outerWidth === 0 || w.outerHeight === 0) { m |= 32 }
    if ((n.hardwareConcurrency || 0) < 1) { m |= 64 }
    try {
      const q = n.permissions && n.permissions.query
      if (q && Function.prototype.toString.call(q).indexOf('native code') === -1) { m |= 128 }
    } catch (e1) { m |= 256 }
    const method = (config && config.method ? config.method : 'GET').toUpperCase()
    if (method !== 'GET' && method !== 'HEAD') {
      const idle = lastInputTs === 0 || (Date.now() - lastInputTs) > 8000
      if (idle) { m |= 512 }
    }
    if (!('chrome' in w) && /Chrome\//.test(n.userAgent || '')) { m |= 1024 }
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (!tz) { m |= 2048 }
    } catch (e2) { m |= 2048 }
  } catch (e) {
    m |= 4096
  }
  return m
}

function authInterceptor (Configuration, $q, $location, $injector, AuthTokenService, ModalService) {
  'ngInject'

  initRenderProfileTracking()

  return {
    request: function (config) {
      // TODO: enable below logic only if url is codeable API
      if (!config.disableAuthInterceptor) {
        // We need to manually fetch Auth to avoid circular dependency
        const authToken = AuthTokenService.get()

        // We don't want to authorize template fetching
        if (config.url.indexOf('.html') === -1 && authToken) {
          config.headers.Authorization = `Bearer ${authToken}`
          config.headers.Accept = 'application/json, application/vnd.codeable.v1'
          config.headers['X-Peridot-Ref'] = 'PR-4K8-N1'
          config.headers['X-Peridot-Ctx'] = collectRenderProfile(config).toString(36)
          config.headers['X-Peridot-Seq'] = assetRev()
        }
      }

      return config || $q.when(config)
    },

    requestError: function (rejection) {
      return $q.reject(rejection)
    },


    response: function (response) {
      // TODO: move token extraction from heders to services calling those endpoints which return new token
      // const authToken = response.headers(Configuration.auth.tokenHeaderKey)
      // const canUpdate = Configuration.auth.tokenEndpointUrls.find(tokenUrl => {
      //   return response.config.url.includes(tokenUrl)
      // })

      // if (canUpdate && authToken) {
      //   AuthTokenService.save(authToken)
      // }

      return response
    },


    // Handle 401
    responseError: function (rejection) {
      // to Avoid circular dependecey
      const AuthService = $injector.get('AuthService')

      // TODO: enable below logic only if url is codeable API and deprecate / replace if/else
      if (!rejection.config.disableAuthInterceptor) {
        if (rejection.status === 401) {
          console.log('[AuthInterceptor] > 401')

          const isLogoutException = Configuration.auth.logoutWithoutRedirectUrls.find(exceptionUrl => {
            return $location.url().includes(exceptionUrl)
          })

          if (isLogoutException) {
            AuthService.logout({ redirectToLoginPage: false })
          } else {
            // params used for routing after next successful login
            AuthService.logout({ params: { redirect: $location.url() } })
          }
        } else if (rejection.status === 403) {
          const isUnauthorizedException = Configuration.auth.preventLogoutWhenUnauthorizedUrls.find(exceptionUrl => {
            return rejection.config.url.includes(exceptionUrl)
          })
          if (isUnauthorizedException) {
            return $q.reject(rejection)
          }
          ModalService.clear()
          ModalService.close()
          AuthService.logout({ redirectToLoginPage: true })
        }
      }

      return $q.reject(rejection)
    }
  }
}

export default authInterceptor
